import React, { useContext, useState } from 'react'
import classNames from 'classnames'
import { AdvertiserRadio } from '../../../../commonComponents/hire/AdvertiserRadio'
import * as Popover from '@radix-ui/react-popover'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import { SharedContext } from '@/context/SharedContext'

export const UpsellOptionCard = ({ option, isSelected = false, onSelect = () => {} }) => {
  const { windowSize } = useContext(SharedContext)
  const isDesktop = windowSize > 768
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)
  const { text, sub_text, amount, crossed_amount, discount, highlights } = option
  const hasCrossed = crossed_amount && crossed_amount !== amount

  const openTooltip = () => setIsTooltipOpen(true)
  const closeTooltip = () => setIsTooltipOpen(false)

  return (
    <div
      onClick={() => onSelect(option)}
      className={classNames(
        'relative flex cursor-pointer justify-between gap-2 rounded-sm bg-white p-16',
        isSelected ? 'border-xs  border-solid border-[#8C630D]' : ''
      )}
      style={{
        boxShadow: !isSelected
          ? '0px 2px 8px 0px rgba(140, 99, 13, 0.20), 0px 5px 30px 2px rgba(140, 99, 13, 0.20)'
          : undefined
      }}
    >
      {/*Main text + price-row */}
      <div className="flex flex-1 flex-col gap-4">
        {/* main text */}
        <div className="flex flex-col gap-[2px]">
          <div className="flex items-center gap-1">
            <div className="text-base leading-21 text-title">{text}</div>
            {highlights?.length > 0 && (
              <Popover.Root open={isTooltipOpen} onOpenChange={setIsTooltipOpen}>
                <Popover.Trigger asChild>
                  <ErrorOutlineOutlinedIcon
                    className="h-[18px] w-[18px] cursor-pointer text-[#4B4B4B]"
                    {...(isDesktop
                      ? {
                          onMouseEnter: openTooltip,
                          onMouseLeave: closeTooltip
                        }
                      : {
                          onClick: () => setIsTooltipOpen((p) => !p)
                        })}
                  />
                </Popover.Trigger>

                <Popover.Portal>
                  <Popover.Content
                    side="top"
                    align="start"
                    sideOffset={4}
                    className="data-[state=open]:animate-fade-in z-50
                             flex w-[280px] max-w-[240px] flex-col gap-2 rounded-sm bg-white p-16 shadow-[0_8px_28px_rgba(0,0,0,0.12)] sm:w-[336px]"
                    onPointerDownOutside={() => {
                      if (!isDesktop) setIsTooltipOpen(false)
                    }}
                  >
                    <div className="text-md font-bold leading-18 text-title">Offer Details</div>
                    <ul className="mb-[0px] list-disc space-y-[6px] pl-[20px] marker:text-sm">
                      {highlights.map((h) => (
                        <li key={h.id} className="text-base leading-24 text-[#323232]">
                          {h.description}
                        </li>
                      ))}
                    </ul>
                    <Popover.Arrow className="fill-white drop-shadow-md" />
                  </Popover.Content>
                </Popover.Portal>
              </Popover.Root>
            )}
          </div>

          {highlights?.length > 0 && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="87"
              height="2"
              viewBox="0 0 87 2"
              fill="none"
            >
              <path
                d="M1.5 1H85.5"
                stroke="url(#paint0_linear_2906_17659)"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_2906_17659"
                  x1="1.5"
                  y1="2.5"
                  x2="85.5"
                  y2="2.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#8C630D" />
                  <stop offset="1" stop-color="#8C630D" stop-opacity="0" />
                </linearGradient>
              </defs>
            </svg>
          )}
        </div>
        {/* price row */}
        <div className="flex flex-col gap-2">
          <div id="upselling_price_details" className="flex items-center gap-1">
            <div id="amount" className="text-[24px] font-bold leading-[30px] text-[#323232]">
              {amount}
            </div>
            {hasCrossed && (
              <div id="crossed_amount" className="text-base leading-21 text-[#666] line-through">
                {crossed_amount}
              </div>
            )}
            {hasCrossed && (
              <div
                id="discount"
                className="inline-flex items-center justify-center rounded-[24px] border-xs border-solid border-[#0174D3] px-xs pt-[2px] pb-[4px] text-[11px] font-bold leading-[14px] text-[#0174d3]"
              >
                {discount} off
              </div>
            )}
          </div>

          <div id="sub_text" className="text-base leading-21 text-[#666]">
            {sub_text}
          </div>
        </div>
      </div>
      {/* radio */}
      <div>
        <AdvertiserRadio
          outerClassName="h-6 w-6 border-[2px] border-[#666666]"
          innerClassName="h-3 w-3 bg-[#8C630D]"
          checkedClassName="border-[2px] border-[#8C630D] bg-white"
          unCheckedClassName="border-[#666666]"
          checked={isSelected}
          onChange={() => onSelect(option)}
        />
      </div>
    </div>
  )
}
